/**
 * Origin for CMS static files (`/public/website-cms/...`).
 * API calls use REACT_APP_HOST_URL_PREFIX (`…/api/v2`); assets are served from the server root.
 */
export function getCmsAssetOrigin() {
  const explicit = process.env.REACT_APP_CMS_ASSET_ORIGIN;
  if (explicit && explicit.trim()) {
    return explicit.trim().replace(/\/$/, "");
  }

  const videoOrigin = process.env.REACT_APP_VIDEO_CALL_REQUEST;
  if (videoOrigin && videoOrigin.trim()) {
    return videoOrigin.trim().replace(/\/$/, "");
  }

  const apiBase = (process.env.REACT_APP_HOST_URL_PREFIX || "").replace(/\/$/, "");
  if (apiBase.endsWith("/api/v2")) {
    return apiBase.slice(0, -"/api/v2".length);
  }

  return apiBase;
}

/**
 * Resolve a CMS image path stored in MongoDB for admin previews.
 * Paths are stored as `/public/website-cms/...` on the backend static host.
 */
export function resolveCmsAssetUrl(src) {
  if (!src || typeof src !== "string") {
    return "";
  }

  const trimmed = src.trim();
  if (!trimmed) {
    return "";
  }

  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }

  const origin = getCmsAssetOrigin();
  if (!origin) {
    return trimmed;
  }

  if (trimmed.startsWith("/public/")) {
    return `${origin}${trimmed}`;
  }

  if (trimmed.startsWith("/images/home")) {
    return `${origin}/public/website-cms${trimmed.replace("/images", "")}`;
  }

  if (trimmed.startsWith("/")) {
    return `${origin}${trimmed}`;
  }

  return trimmed;
}
